module.exports = __webpack_public_path__ + "e2967d8f228ae65c9bb07266027902f8.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/path1.svg
// module id = 616
// module chunks = 0